import React from 'react'
import { Progress } from '@/components/ui/progress'
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react'

interface UpdateProgressTrackerProps {
  current: number
  total: number
  successCount: number
  failedCount: number
  currentTransaction?: string
}

export function UpdateProgressTracker({
  current,
  total,
  successCount,
  failedCount,
  currentTransaction
}: UpdateProgressTrackerProps) {
  const percent = total > 0 ? Math.round((current / total) * 100) : 0
  
  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center text-sm">
        <div className="font-medium">Updating transactions...</div>
        <div>{current} of {total}</div>
      </div>
      
      <Progress value={percent} className="h-2" />
      
      <div className="flex justify-between text-xs mt-2">
        <div className="flex items-center">
          <CheckCircle className="h-4 w-4 text-green-500 mr-1" />
          <span>{successCount} successful</span>
        </div>
        
        {failedCount > 0 && (
          <div className="flex items-center">
            <AlertCircle className="h-4 w-4 text-red-500 mr-1" />
            <span>{failedCount} failed</span>
          </div>
        )}
      </div>
      
      {currentTransaction && (
        <div className="flex items-center text-xs text-gray-500 mt-1">
          <Loader2 className="h-3 w-3 mr-1 animate-spin" />
          <span>Currently updating: {currentTransaction}</span>
        </div>
      )}
    </div>
  )
} 